import React from 'react';
import { EnochFilterContext } from './context';
import useGetSetState from 'react-use/lib/useGetSetState';
import GeneralEnochReport from './GeneralEnochReport';
import HistogramEnochReport from './HistogramEnochReport';
import EnochReportFilter from './EnochReportFilter';
import moment from 'moment/moment';
import { enochFilterDateFormat } from './common';
import RunHistory from './RunHistory';
import VMHistory from './VMHistory';

export default function EnochPerf() {
  const [getFilter, setFilter] = useGetSetState({
    email: null,
    ipAddress: null,
    // Default to last 28 days
    fromDate: moment()
      .subtract(28, 'days')
      .format(enochFilterDateFormat),
    toDate: moment().format(enochFilterDateFormat),
  });
  return (
    <EnochFilterContext.Provider value={getFilter()}>
      <div
        style={{
          display: 'flex',
          flex: 1,
          overflow: 'hidden',
          flexDirection: 'column',
        }}
      >
        <EnochReportFilter setFilter={setFilter} />
        <h4>General Metrics</h4>
        <GeneralEnochReport />
        <h4>Metrics by Date</h4>
        <HistogramEnochReport />
        <h4>Enoch Run History</h4>
        <RunHistory />
        <h4>Enoch Run History By VM</h4>
        <VMHistory />
      </div>
    </EnochFilterContext.Provider>
  );
}
